module.exports = __webpack_public_path__ + "static/img/noInfo.e8d7173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/noInfo.png
// module id = 4k+I
// module chunks = 1